var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',{attrs:{"state":_vm.state,"value":_vm.value,"placeholder":"Valitse tiedosto...","browse-text":"Selaa"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }